<template>
  <div v-if="isUserProfileLoaded">


    <div class="columns">
      <div class="column is-half">
        
        <div class="columns">
          <!-- <div class="column is-one-fifth">
          </div> -->
          

          <div class="column" style="padding: 10%">


            <section>
              <div><b>Account data</b></div>
              <br>
              <b-field label="Company Name" label-position="on-border">
                  <b-input type="text" placeholder="Company Name"  
                      v-model="localAccount.aname"
                      maxlength="30">
                  </b-input>
              </b-field>

              <b-field label="Company Name" label-position="on-border">
                  <b-input type="text" placeholder="Company Name"  
                      v-model="localAccount.aname"
                      maxlength="30">
                  </b-input>
              </b-field>

              <b-field label="Company ID" label-position="on-border">
                  <b-input type="text" placeholder="Company ID"  
                      v-model="localAccount.aid"
                      maxlength="30">
                  </b-input>
              </b-field>

              <b-field label="VAT number" label-position="on-border">
                  <b-input type="text" placeholder="Vat number"  
                      v-model="localAccount.avat"
                      maxlength="30">
                  </b-input>
              </b-field>

              <b-field label="VAT registration number" label-position="on-border">
                  <b-input type="text" placeholder="Vat registration number"  
                      v-model="localAccount.avatreg"
                      maxlength="30">
                  </b-input>
              </b-field>
              
              <b-field label="Registered Office" label-position="on-border">
                  <b-input maxlength="200" type="textarea" v-model="localAccount.aoffice"></b-input>
              </b-field>

              <b-field label="Opening hours" label-position="on-border">
                  <b-input maxlength="200" type="textarea" v-model="localAccount.ahours"></b-input>
              </b-field>

              <b-field label="Short Profile" label-position="on-border">
                  <b-input maxlength="200" type="textarea" v-model="localAccount.ashortprofile"></b-input>
              </b-field>

            </section>

            <div class="buttons my-center-horizontal" @click="onSaveAccount">
              
              <a class="button is-primary">
                <strong>SAVE</strong>
              </a>
            </div>
          </div>

          <!-- <div class="column is-one-fifth">
          </div> -->

        </div>


      </div>
      <div class="column is-half">
        <div class="column" style="padding: 10%">

        <section>
          <div><b>Settings</b></div>
          <br>
          
          <b-field label="Type of Business" label-position="on-border">
              <b-input disabled type="text" v-model="localAccount.businesstype"></b-input>
          </b-field>

          <b-field label="Alert Time [days]" label-position="on-border">
              <b-input disabled rounded v-model="localAccount.alerttime"></b-input>
          </b-field>

          <b-field label="Return Time [days]" label-position="on-border">
              <b-input disabled rounded v-model="localAccount.returntime"></b-input>
          </b-field>
          

          <b-field grouped group-multiline>
                <div v-for="tag in localAccount.ctags" :key="tag">
                  <div style="margin:0.2em; padding:0.2em; min-width: 3em; background: green; color: white;">{{tag}}</div>
                </div>
          </b-field>

            <br> 
            <!-- Change Settings:  -->
            <b-button type="button is-light" aria-label="toggle" @click.prevent="toggleEditSettings">
            Change Settings: 
              <i class="fas fa-chevron-circle-down" style="font-size:1.8em;" v-if="!isEditSettingsActive" ></i>
              <i class="fas fa-chevron-circle-up" style="font-size:1.8em;" v-if="isEditSettingsActive" ></i>
            
            </b-button>

          <div v-if="isEditSettingsActive" style="background: gray; padding: 20px;">  

            <!-- {{localSelectedType}} -->

            <b-field label="Type of Business" >
              <b-select v-model="localSelectedType" @input="onSetPresetValues" expanded>  
                <option value="">Select Type of Business</option>
                <option v-for="value in typesOfBusiness"
                        :value="value" v-bind:key="value.id">
                  {{ value.name }} 
                </option>
              </b-select>
            </b-field>

            <div v-if="localSelectedType">

              <b-field label="Alert Time [days]" label-position="on-border">
                  <b-numberinput min="0" max="30" rounded v-model="localSelectedType.alerttime"></b-numberinput>
              </b-field>

              <b-field label="Return Time [days]" label-position="on-border">
                  <b-numberinput min="0" max="365" rounded v-model="localSelectedType.returntime"></b-numberinput>
              </b-field>

              <b-field label="Customer Classification Labels" label-position="on-border">
                  <b-taginput
                      v-model="localSelectedType.ctags"
                      ellipsis
                      icon="label"
                      placeholder="Add a tag">
                  </b-taginput>
              </b-field>

              <b-button type="button is-primary" aria-label="toggle" @click="saveSettings">

                SAVE
              </b-button>
            </div>
          </div>


        </section>
        </div>




        <div style="left: 50%">
          <img alt="Vue logo" src="@/assets/logo.png">

          <!-- <div class="buttons my-center-horizontal" >
            <a class="button is-primary">
              <strong>Update Picture</strong>
            </a>
          </div> -->

          <div>
            <b-field class="file">
                <b-upload v-model="localAccount.pic">
                    <a class="button is-primary">
                        <b-icon icon="upload"></b-icon>
                        <span>Click to upload</span>
                    </a>
                </b-upload>
                <span class="file-name" v-if="localAccount.pic">
                    {{ localAccount.pic }}
                </span>
            </b-field>

          </div>

        </div>

      </div>
    </div>

        

    
  
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import { typesOfBusiness } from '@/utils/settings';

  export default {
    name: 'AccountProfile',
    components: {
    },
    data() {
      return  {
        localAccount: null,
        typesOfBusiness: [],
        localSelectedType: null,
        isEditSettingsActive: false
      }
    },
    created () {
      this.localAccount = JSON.parse(JSON.stringify(this.getAccount))
      // console.log(this.localAccount)
      this.typesOfBusiness = typesOfBusiness

    },
    computed: {
      ...mapGetters(['getAccount', 'isUserProfileLoaded']),
      // ...mapState(['user', 'account'])
    },
    
    methods: {
      ...mapActions(['saveAccount']),
      onSaveAccount () {
        // console.log(this.localAccount)
        this.saveAccount(this.localAccount)
      },
      onSetPresetValues() {
        // this.localAccount.businesstype = this.localSelectedType.name
        // console.log("log >> "+JSON.stringify(this.localSelectedType))
      },
      toggleEditSettings() {
        this.isEditSettingsActive = !this.isEditSettingsActive
      },
      saveSettings () {
        this.localAccount.businesstype = this.localSelectedType.name
        this.localAccount.alerttime = this.localSelectedType.alerttime
        this.localAccount.returntime = this.localSelectedType.returntime
        this.localAccount.ctags = this.localSelectedType.ctags
        
        this.isEditSettingsActive = false
      }
    
    },
    watch: {
      getAccount (newVal) {
        this.localAccount = JSON.parse(JSON.stringify(newVal))
      }
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    .myheaderbar {
      height: 3em;
      line-height: 3em;
      background: lightgray;
      text-align: left;
      padding-left: 1em;
    }
    .mybuttons {
      justify-content: center;
    }
    .my-center-horizontal {
      display: block;
    }
</style>